"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _isPlainObject = require('is-plain-object');
function isPlainObject(thing) {
    return _isPlainObject(thing);
}
exports.isPlainObject = isPlainObject;
